import useSWR from "swr";

import salesDashboardService from "@/services/sales-dashboard.service";

export interface UseGetAverageOrderAmountProps {
  startDate: string;
  endDate: string;
}

export type UseGetAverageOrderAmountReturn = {
  data: {
    currentPeriodAverageOrderAmount: number;
    previousPeriodAverageOrderAmount: number;
    percentageIncrease: number;
  } | null;
  isLoading: boolean;
  error: Error | null;
};

const useGetAverageOrderAmount = ({
  startDate,
  endDate,
}: UseGetAverageOrderAmountProps): UseGetAverageOrderAmountReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR(
    ["getAverageOrderAmount", startDate, endDate],
    () => salesDashboardService.averageOrderAmount(startDate, endDate),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetAverageOrderAmount;
